export const divisionFormUpdate = ({ prop, value }) => {

    return {
        type: 'DIVISION_FORM_UPDATE',
        field: { prop, value }
    };
};

export const divisionFormError = (message) => {

    return {
        type: 'DIVISION_FORM_ERROR',
        message
    };
};

export const divisionFormSuccess = (message) => {

    return {
        type: 'DIVISION_FORM_SUCCESS',
        message
    };
};

export const divisionFormReset = () => {
    
    return {
        type: 'DIVISION_FORM_RESET',
    };
}